'use strict';

angular.module('header')

.controller('HeaderCtrl', function ($scope, $rootScope, $uibModal, kdAuth, kdLogin, kdGate, CurrentUserModal, $state, $timeout)
{
    $scope.navCollapsed = true;
    $scope.navAdmin = $state.includes('admin');
    $scope.kdAuth = kdAuth;
    $scope.kdLogin = kdLogin;
    $scope.CurrentUserModal = CurrentUserModal;
    $scope.isCollapsed = false;

    $scope.showDivider = function ()
    {
        return $scope.printer || $scope.videoEditor || kdGate.check('admin');
    };

    $scope.userSettingsModal = function ()
    {
        $uibModal.open({
            animation: true,
            templateUrl: 'modules/user-settings/userSettings.html',
            windowClass: 'user-settings-modal',
            controller: 'UserSettingsCtrl',
            controllerAs: '$ctrl'
        });
    };

    $rootScope.$on('$stateChangeSuccess', function()
    {
        $scope.navAdmin = $state.includes('admin');
    });
});
